angular.module('galilai.creator').controller('CarouselController', function ($timeout, $scope, api, $rootScope) {
    $scope.inputs = {
        mode: 'auto',
        selectedTemplate: 'default',
        focus: 'authority',
        selectedTemplateName: null,
        templateContent: '',
        editing: false,
        cta: null,
    }

    let CACHED_TEMPLATES = {
        'authority': null,
        'sales': null,
    }
    $scope.templates = []
    $scope.ctas = []

    $rootScope.$on('showCarouselCreator', function () {
        let carouselModal = angular.element('#carousel-modal')

        // initialize modal with options
        carouselModal.modal({
            backdrop: 'static',
            keyboard: false
        })

        // then show it
        carouselModal.modal('show')

        $scope.updateTemplates();
    })

    function fixCtaSelection() {
        if ($scope.inputs.cta != null && $scope.ctas.length > 0) {
            let foundCta = $scope.ctas.find(cta => cta.id === $scope.inputs.cta.id);
            if (foundCta) {
                $scope.inputs.cta = foundCta;
            } else {
                $scope.inputs.cta = $scope.ctas[0];
            }
        } else if ($scope.inputs.cta == null && $scope.ctas.length > 0) {
            $scope.inputs.cta = $scope.ctas[0];
        }
    }
    $scope.updateTemplates = function () {
        if (CACHED_TEMPLATES[$scope.inputs.focus]) {
            $scope.templates = CACHED_TEMPLATES[$scope.inputs.focus].templates;
            $scope.ctas = CACHED_TEMPLATES[$scope.inputs.focus].ctas;
            fixCtaSelection()
            return;
        }

        api.getCarouselTemplates($scope.inputs.focus).then(function (response) {
            $scope.templates = response.data.templates
            $scope.ctas = response.data.ctas
            // Add default and custom options
            $scope.templates.unshift(
                {
                    id: 'default',
                    name: gettext('label.carousel_default'),
                }
            )
            CACHED_TEMPLATES[$scope.inputs.focus] = response.data
            fixCtaSelection()
        });
    }

    $scope.activateTemplate = function (item) {
        $scope.inputs.selectedTemplate = item.id;
        if (item.id === 'custom' || item.id === 'default') {
            $scope.inputs.selectedTemplateName = null;
            return
        }
        $scope.inputs.selectedTemplateName = item.name;
        $scope.inputs.templateContent = item.content;
        $scope.inputs.editing = true;

        $scope.onChangeCTA($scope.inputs.cta);
    }


    $scope.onChangeCTA = function (cta) {
        $scope.inputs.cta = cta;
        if (!$scope.inputs.cta.description) {
            return;
        }
        // Replace last line of templateContent with cta.description
        let lines = $scope.inputs.templateContent.split('\n');
        lines[lines.length - 1] = '- ' + $scope.inputs.cta.description;
        $scope.inputs.templateContent = lines.join('\n');
    }

    $scope.generatePages = function () {
        let template = {}
        if ($scope.inputs.mode == 'custom') {
            template = {
                objective: $scope.inputs.objective,
                name: $scope.inputs.selectedTemplateName,
                content: $scope.inputs.templateContent
            }
            if ($scope.inputs.selectedTemplate == 'default') {
                delete template.name;
                delete template.content;
            }
        } else if ($scope.inputs.mode == 'auto') {
            template = {
                name: '_auto_',
            }
        }

        $rootScope.$broadcast('getPost', {
            type: 'generateInitialContent',
            template: template,
        })
        // Hide modal
        let carouselModal = angular.element('#carousel-modal')
        carouselModal.modal('hide');
    }
})